import {
  GET_VIDEO_RESUME, GET_VIDEO_RESUME_SUCCESSFULL, GET_VIDEO_RESUME_FAILED
} from "./actionTypes"

export const getVideoResume = (candidateId, download) => {
  return {
    type: GET_VIDEO_RESUME,
    payload: { candidateId, download },
  }
}

export const getVideoResumeSuccessfull = user => {
  return {
    type: GET_VIDEO_RESUME_SUCCESSFULL,
    payload: user,
  }
}

export const getVideoResumeFailed = user => {
  return {
    type: GET_VIDEO_RESUME_FAILED,
    payload: user,
  }
}